import React from 'react'
import CaSideNav from '../../../../components/AdminComponents/CaSideNav'
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
    CaAdminMenu,
    SecondaryNavAuditCA,
  } from "../../../../components/AdminComponents/MenuItems";
import EmailTable from './Tables/EmailTable';


const EmailTrail = () => {
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavAuditCA} />
      <EmailTable />
      </CaSideNav>
  )
}

export default EmailTrail